/**
 * Caché global para datos solares actuales
 * Permite mostrar datos inmediatamente al volver al tab de flujo
 */

interface CachedSolarData {
  data: any;
  timestamp: number;
}

class SolarDataCache {
  private cache: CachedSolarData | null = null;
  private readonly MAX_AGE_MS = 2 * 60 * 1000; // 2 minutos - datos se actualizan cada minuto

  /**
   * Obtiene datos del caché si están disponibles y no están expirados
   */
  get(): any | null {
    if (!this.cache) {
      return null;
    }

    const age = Date.now() - this.cache.timestamp;
    if (age > this.MAX_AGE_MS) {
      // Datos expirados, limpiar caché
      this.cache = null;
      return null;
    }

    return this.cache.data;
  }

  /**
   * Guarda datos en el caché
   */
  set(data: any): void {
    if (data && data.inversores && Array.isArray(data.inversores) && data.inversores.length > 0) {
      // Validar que los datos sean válidos antes de guardar
      const hasValidInverter = data.inversores.some(
        (inv: any) => inv && inv.inversor_id !== null && inv.inversor_id !== undefined
      );
      
      if (hasValidInverter) {
        this.cache = {
          data,
          timestamp: Date.now()
        };
      }
    }
  }

  /**
   * Verifica si hay datos en caché (incluso si están expirados)
   */
  hasCache(): boolean {
    return this.cache !== null;
  }

  /**
   * Obtiene la edad del caché en milisegundos
   */
  getAge(): number {
    if (!this.cache) {
      return Infinity;
    }
    return Date.now() - this.cache.timestamp;
  }

  /**
   * Limpia el caché
   */
  clear(): void {
    this.cache = null;
  }

  /**
   * Verifica si los datos en caché están frescos (menos de MAX_AGE_MS)
   */
  isFresh(): boolean {
    if (!this.cache) {
      return false;
    }
    return this.getAge() <= this.MAX_AGE_MS;
  }
}

// Exportar instancia singleton
export const solarDataCache = new SolarDataCache();






